import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Slide } from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import React, { createContext, ReactNode, useContext, useState } from "react";

const Transition = React.forwardRef(function Transition(
	props: TransitionProps & { children: React.ReactElement<any, any> },
	ref: React.Ref<unknown>
) {
	return <Slide direction="up" ref={ref} {...props} />;
});

interface DialogContextProps {
	showDialog: (title: string, message: string) => void;
}

const DialogContext = createContext<DialogContextProps | undefined>(undefined);

export const DialogProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
	const [open, setOpen] = useState(false);
	const [message, setMessage] = useState("");
	const [title, setTitle] = useState("");

	const showDialog = (title: string, msg: string) => {
		setMessage(msg);
		setTitle(title);
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	return (
		<DialogContext.Provider value={{ showDialog }}>
			{children}
			<Dialog
				open={open}
				TransitionComponent={Transition}
				keepMounted onClose={handleClose}
				fullWidth
				sx={{ zIndex: 1500 }}
			>
				<DialogTitle>{title}</DialogTitle>
				<DialogContent>
					<DialogContentText sx={{ whiteSpace: 'pre-line' }}>{message}</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose}>Fechar</Button>
				</DialogActions>
			</Dialog>
		</DialogContext.Provider>
	);
};

export const useDialog = () => {
	const context = useContext(DialogContext);
	if (!context) {
		throw new Error("useDialog deve ser usado dentro de um DialogProvider");
	}
	return context;
};
